// Message	ENDPOINT_NOT	DRIVER_APP	AUTO_APPROVAL_ACTION_TOOLTIP: 'The d};

// General application messages that might be used across componentsfault action to take when auto-approval is enabled',OVAL_FEATURE_TOOLTIP: 'Driver approval system is always enabled for this tenant',FOUND: 'Driver approval settings endpoint not found. Using default settings.',constants for the application
// This file can be easily converted to an i18n system later

export const DRIVER_APPROVAL_MESSAGES = {
	// Success messages
	SETTINGS_UPDATED_SUCCESS: 'Driver approval settings updated successfully',

	// Error messages
	FAILED_TO_LOAD: 'Driver approval settings are not configured yet. Please add the settings to continue.',
	FAILED_TO_UPDATE: 'Failed to update driver approval settings',
	ENDPOINT_NOT_FOUND: 'Driver approval settings endpoint not found. Using default settings.',
	UNKNOWN_ERROR: 'Unknown error',
	SERVER_ERROR: 'We’re experiencing a server error. Please try again in a moment.',
	// Alert descriptions
	MANUAL_APPROVAL_FLOW:
		'Manual approval required - All new driver registrations will be pending until manually reviewed.',
	AUTO_APPROVAL_FLOW: (action) =>
		`Auto-approval enabled - New drivers will be automatically ${action.toLowerCase()}.`,
	NO_AUTO_APPROVAL_FLOW:
		'No automatic approval process - New drivers will require manual configuration.',

	// Form labels and tooltips
	DRIVER_APPROVAL_FEATURE_LABEL: 'Driver Approval Feature',
	DRIVER_APPROVAL_FEATURE_TOOLTIP: 'Driver approval system is always enabled for this tenant',

	MANUAL_APPROVAL_LABEL: 'Manual Approval Required',
	MANUAL_APPROVAL_TOOLTIP:
		'When enabled, all new driver registrations require manual review and approval',

	AUTO_APPROVAL_LABEL: 'Auto Approval Enabled',
	AUTO_APPROVAL_TOOLTIP:
		'When manual approval is not required, this setting determines if drivers are automatically processed',

	AUTO_APPROVAL_ACTION_LABEL: 'Auto Approval Action',
	AUTO_APPROVAL_ACTION_TOOLTIP: 'The default action to take when auto-approval is enabled',

	// Button texts
	REFRESH: 'Refresh',
	RESET: 'Reset',
	SAVE_CHANGES: 'Save Changes',

	// Switch texts
	ENABLED: 'Enabled',
	DISABLED: 'Disabled',
	REQUIRED: 'Required',
	NOT_REQUIRED: 'Not Required',

	// Select options
	AUTO_APPROVE: 'Auto Approve',
	AUTO_DENY: 'Auto Deny',

	// Tooltip messages
	UNSAVED_CHANGES: 'You have unsaved changes',
	LAST_SAVED: (time) => `Last saved: ${time}`,

	// Configuration guidelines
	GUIDELINES_TITLE: 'Configuration Guidelines:',
	GUIDELINE_DRIVER_APPROVAL:
		'Always enabled for this tenant. The driver approval system ensures proper onboarding workflow for all new driver registrations.',
	GUIDELINE_MANUAL_APPROVAL:
		'Use this for strict control over driver onboarding. All applications will be pending until manually reviewed.',
	GUIDELINE_AUTO_APPROVAL:
		'When manual approval is disabled, this setting determines automatic processing of new registrations.',
	GUIDELINE_AUTO_APPROVAL_ACTION:
		'Choose whether to automatically approve or deny new driver applications when auto-approval is enabled.',

	// Card titles and alert titles
	CARD_TITLE: 'Driver Approval Settings',
	CURRENT_APPROVAL_FLOW: 'Current Approval Flow',
	ERROR_TITLE: 'Driver Approval Settings Required',
};

export const RIDER_APPROVAL_MESSAGES = {
	// Success messages
	SETTINGS_UPDATED_SUCCESS: 'Rider approval settings updated successfully',

	// Error messages
	FAILED_TO_LOAD: 'Rider approval settings are not configured yet. Please add the settings to continue.',
	FAILED_TO_UPDATE: 'Failed to update rider approval settings',
	ENDPOINT_NOT_FOUND: 'Rider approval settings endpoint not found. Using default settings.',
	UNKNOWN_ERROR: 'Unknown error',
	SERVER_ERROR: 'We’re experiencing a server error. Please try again in a moment.',

	// Alert descriptions
	MANUAL_APPROVAL_FLOW:
		'Manual approval required - All new rider registrations will be pending until manually reviewed.',
	AUTO_APPROVAL_FLOW: (action) =>
		`Auto-approval enabled - New riders will be automatically ${action.toLowerCase()}.`,
	NO_AUTO_APPROVAL_FLOW:
		'No automatic approval process - New riders will require manual configuration.',

	// Form labels and tooltips
	DRIVER_APPROVAL_FEATURE_LABEL: 'Rider Approval Feature',
	DRIVER_APPROVAL_FEATURE_TOOLTIP: 'Rider approval system is always enabled for this tenant',

	MANUAL_APPROVAL_LABEL: 'Manual Review',
	MANUAL_APPROVAL_TOOLTIP:
		'When enabled, all new rider registrations require manual review and approval',

	AUTO_APPROVAL_LABEL: 'Auto Review',
	AUTO_APPROVAL_TOOLTIP:
		'When manual approval is not required, this setting determines if riders are automatically processed',

	AUTO_APPROVAL_ACTION_LABEL: 'Auto Review Action',
	AUTO_APPROVAL_ACTION_TOOLTIP: 'The default action to take when auto-approval is enabled',

	// Button texts
	REFRESH: 'Refresh',
	RESET: 'Reset',
	SAVE_CHANGES: 'Save Changes',

	// Switch texts
	ENABLED: 'Enabled',
	DISABLED: 'Disabled',
	REQUIRED: 'Required',
	NOT_REQUIRED: 'Not Required',

	// Select options
	AUTO_APPROVE: 'Auto Approve',
	AUTO_DENY: 'Auto Deny',

	// Tooltip messages
	UNSAVED_CHANGES: 'You have unsaved changes',
	LAST_SAVED: (time) => `Last saved: ${time}`,

	// Configuration guidelines
	GUIDELINES_TITLE: 'Configuration Guidelines:',
	GUIDELINE_DRIVER_APPROVAL:
		'Always enabled for this tenant. The rider approval system ensures proper onboarding workflow for all new rider registrations.',
	GUIDELINE_MANUAL_APPROVAL:
		'Use this for strict control over rider onboarding. All applications will be pending until manually reviewed.',
	GUIDELINE_AUTO_APPROVAL:
		'When manual approval is disabled, this setting determines automatic processing of new registrations.',
	GUIDELINE_AUTO_APPROVAL_ACTION:
		'Choose whether to automatically approve or deny new rider applications when auto-approval is enabled.',

	// Card titles and alert titles
	CARD_TITLE: 'Rider Approval Settings',
	CURRENT_APPROVAL_FLOW: 'Current Approval Flow',
	ERROR_TITLE: 'Rider Approval Settings Required',
};

// General application messages that might be used across components
export const GENERAL_MESSAGES = {
	SOMETHING_WENT_WRONG: 'Something went wrong. Please try again later.',
	LOADING: 'Loading...',
	SAVE: 'Save',
	CANCEL: 'Cancel',
	SUCCESS: 'Success',
	ERROR: 'Error',
	WARNING: 'Warning',
	INFO: 'Info',
};
